import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	unreadTotalNotificationCount: 0,
	// unreadInprogressNotificationCount: 0,
	// unreadCompletedNotificationCount: 0,
	unreadReminderNotificationCount: 0,
	refetchReminderCount: 0,
};

// ==============================|| SLICE - MENU ||============================== //

const processSlice = createSlice({
	name: 'process',
	initialState,
	reducers: {
		setNotification(state, action) {
			state.unreadTotalNotificationCount = action.payload.countTotal;
			// state.unreadInprogressNotificationCount = action.payload.countOpen;
			// state.unreadCompletedNotificationCount = action.payload.countComplete;
		},
		setMarkAsReadForNotification(state, action) {
			if (action.payload.type === 'TOTAL') {
				state.unreadTotalNotificationCount = 0;
			}
			// else if (action.payload.type === 'OPEN' && state.unreadInprogressNotificationCount > 0) {
			//   const unseenLeft = state.unreadInprogressNotificationCount - action.payload.size;
			//   state.unreadInprogressNotificationCount = unseenLeft > -1 ? unseenLeft : 0;
			// } else if (action.payload.type === 'COMPLETE' && state.unreadCompletedNotificationCount > 0) {
			//   const unseenLeft = state.unreadCompletedNotificationCount - action.payload.size;
			//   state.unreadCompletedNotificationCount = unseenLeft > -1 ? unseenLeft : 0;
			// }
		},
		refetchNotificationCount(state) {
			state.refetchNotificationCount = new Date();
		},
		setReminderNotification(state, action) {
			state.unreadReminderNotificationCount = action.payload.unreadReminderNotificationCount;
		},
		// setMarkAsReadForReminderNotification(state) {
		// 	state.unreadReminderNotificationCount = 0;
		// },
		resetProcess(state) {
			state.unreadTotalNotificationCount = 0;
			state.unreadReminderNotificationCount = 0;
		},
	},
});

export default processSlice.reducer;

export const {
	setNotification,
	setMarkAsReadForNotification,
	refetchNotificationCount,
	setReminderNotification,
	// setMarkAsReadForReminderNotification,
	resetProcess,
} = processSlice.actions;
